import { Record as ImmutableRecord, type RecordOf } from 'immutable';
import type { DateTime } from 'luxon';

import type { QcsSyncResourceStore, QcsSyncResourceStoreProps } from 'app-components/flux/core/resourceStoreTypes';

export const SHARES_REDUCER_KEY = 'shareStore';

export type ShareProps = {
  id?: string;
  clientId?: string;

  datasetId?: string;

  granteeFirstName?: string;
  granteeLastName?: string;
  granteeEmail?: string;

  grantorFirstName?: string;
  grantorLastName?: string;
  grantorEmail?: string;

  permissions?: string;
  state?: string;

  lastAccessedAt?: string;

  testMode?: boolean;

  createdAt?: string | DateTime;
  isDeleted?: boolean;
};

export type Share = RecordOf<ShareProps>;
export type ShareInput = Share | ShareProps;
export type SharesStoreProps = QcsSyncResourceStoreProps<ShareProps>;
export type SharesStore = QcsSyncResourceStore<ShareProps, SharesStoreProps>;

export const mkShare = ImmutableRecord<ShareProps>({
  id: undefined,
  clientId: undefined,

  datasetId: undefined,

  granteeFirstName: undefined,
  granteeLastName: undefined,
  granteeEmail: undefined,

  grantorFirstName: undefined,
  grantorLastName: undefined,
  grantorEmail: undefined,

  permissions: '0',
  state: undefined,

  lastAccessedAt: undefined,

  testMode: false,

  createdAt: undefined,
  isDeleted: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [SHARES_REDUCER_KEY]: SharesStore;
  }
}
